import React from 'react';

import { useComments } from 'scenes/Gallery/GalleryPage/Creatives/Comments/data';

const CommentsContext = React.createContext({
  data: [],
  isLoading: false,
});

export const CommentsProvider = ({ creativeId, children }) => {
  const { data, isLoading } = useComments(creativeId);

  return (
    <CommentsContext.Provider
      value={{
        isLoading: isLoading,
        data,
        creativeId,
      }}
    >
      {children}
    </CommentsContext.Provider>
  );
};
export default CommentsContext;
